import React from 'react';
import { BasketItem } from '@common/components/BasketItem';
import BASKET_UPDATE_TYPES from '@routes/Basket/components/BasketUpdateTypes';
import { Price, Discount, Personalization } from 'shared-types/Common';
import { Routes } from '@common/constants';
import { EventDetails } from './EventDetails';
import { EventMetadata, EventMetadataProps } from './EventMetadata';

export type Item = {
  type: 'events';
  linkRoute?: string;
  /**
   * @deprecated Migrating to fulfilables service typings
   */
  event: any;
  /**
   * @deprecated Migrating to fulfilables service typings
   */
  option: any;
  id: number;
  quantity: number;
  price: Price;
  discount?: Discount;
  personalization: Personalization;
  deliveryDetails?: {
    method: string;
    packagingName: string;
    email: string | null;
  };
  eventId?: number;
  expireAt?: string;
  detailsBag?: {
    discount: {
      fullPrice: string; // e.g. £85.00
      fullPriceAsInt: number; // e.g. 8500
      discountedPrice: string; // e.g. £63.75
      discountedPriceAsInt: number; // e.g. 6375
      name: string;
      type: 'Percentage' | 'Fixed';
      value: string; // e.g. '25', i.e. value of the discount reduction itself
    };
    images: string[];
    name: string;
    price: string;
    priceAsInt: number;
    terms: string;
  };
} & Pick<EventMetadataProps, 'eventOption'>;

export type EventProps = {
  isEditable: boolean;
  item: Item;
  isQuantityPickerHidden: boolean;
  onChange: (
    type: BASKET_UPDATE_TYPES.QUANTITY | BASKET_UPDATE_TYPES.REMOVE,
    itemId: number | string,
    quantity?: number
  ) => void;
};

export const Event: React.FC<EventProps> = ({ isEditable = true, item, onChange }) => {
  const {
    linkRoute = Routes.EVENT_DETAIL,
    event,
    option,
    id,
    price,
    eventOption,
    detailsBag,
  } = item;
  const linkParams = {
    id: event.id,
  };
  const name = `${event.name} ${option ? `- ${option.name}` : ''}`;
  function renderMetadata() {
    return <EventMetadata eventOption={eventOption} eventDatetime={event.eventDatetime} />;
  }

  function handleEventRemoval() {
    onChange(BASKET_UPDATE_TYPES.REMOVE, id);
  }

  return (
    <BasketItem
      key={id}
      name={name}
      linkParams={linkParams}
      linkRoute={linkRoute}
      thumbnail={event?.mainImageUrl}
      price={
        detailsBag?.discount
          ? { amount: detailsBag.discount.fullPriceAsInt, currencyCode: price.currencyCode }
          : price
      }
      discount={
        detailsBag?.discount
          ? {
              discountedPrice: {
                amount: detailsBag.discount.discountedPriceAsInt,
                currencyCode: price.currencyCode,
              },
              standardPrice: price,
            }
          : undefined
      }
      renderMetadata={renderMetadata}
      renderDetails={<EventDetails item={item} isEditable={isEditable} />}
      shouldRenderMobileDetails={true}
      isEditable={isEditable}
      onRemove={handleEventRemoval}
    />
  );
};
